import type { InferOutput } from 'valibot'
import { email, fallback, nullish, object, optional, parser, pipe, picklist, string, transform } from 'valibot'

export const loginBodySchema = object({
  email: pipe(string(), email()),
  password: nullish(string()),
})

const SAME_ORIGIN_BASE = 'https://juridika.invalid'

export function toSameOriginPath(value: string): string | undefined {
  if (!value.startsWith('/')) {
    return
  }

  let url: URL
  try {
    url = new URL(value, SAME_ORIGIN_BASE)
  } catch {
    return
  }

  const path = url.pathname + url.search + url.hash
  if (url.origin !== SAME_ORIGIN_BASE || path.startsWith('//')) {
    return
  }
  return path
}

export const redirectToQuerySchema = object({
  redirectTo: fallback(
    optional(
      pipe(
        string(),
        transform(toSameOriginPath),
      ),
    ),
    undefined,
  ),
})

export const redirectToQueryParser = parser(redirectToQuerySchema)

export type RedirectToQuery = InferOutput<typeof redirectToQuerySchema>

export const issuerSchema = picklist(['am', 'auth0'])

export type Issuer = InferOutput<typeof issuerSchema>